import Model from '@/models/Model'

export default class PosDetailCustomerReceivablePayment extends Model {
    resource() {
        return 'pos_detail_customer_receivable_payment'
    }
}